/**
 * Collection of plays
 * 
 * @class Collection_Search
 */

Collection_Search = (function (BaseCollection) {
    var Collection_Search = function () {
        this.construct.apply(this, arguments);
    };

    $.extend(true, Collection_Search.prototype, BaseCollection.prototype, {
		/**
		 * @inheriteddoc Collection#fetch
		 * @returns promise
		 */
        fetch: function (params) {
            return new Promise(function (resolve, reject) {
                this.config.reqParams = (params ? params.reqParams : this.config.reqParams) || this.config.reqParams;
                this.reset();
                console.log('COLLECTION SEARCH');
                console.log('PARAM: ' + params);

                API.fetchPlaysSearch()
                    .bind(this)
                    .then(function (resp) {
                        if (resp) {
                            this.parseData(resp.data);
                            resolve();
                        } else {
                            reject();
                        }
                    })
                    .catch(function (err) {
                        App.throbberHide();
                        App.notification(__(err));
                        reject();
                    });
            }.bind(this))
        },

        setData: function(data){
            this.setTitle(data.name);
            this.parseData(data.plays || data);
        },

        setTitle: function(title) {
            this.title = title;
        },

        getTitle: function() {
            return this.title;
        },

		/**
		 * parsing response to collection
		 * @param {Array of object} data
		 */
        parseData: function (data, scene, snippet) {
            var items = (data instanceof Array) ? data : obj2arr(data) || [],
                item;

            function obj2arr(obj) {
                var arr = _.map(obj, function (value, index) {
                    return value;
                });
                return arr;
            }

            for (var i = 0; i < items.length; i++) {
                item = items[i];
                this.push(item);
                // added reference to the order
                this.models[i].data.relId = i;
            }
        },

		/**
		 * To get Model specified by given id
		 * @param {String} id of asset
		 * @returns {Model} 
		 */
        getById: function (id) {
            for (var i = 0; i < this.models.length; i++) {
                if (this.models[i].getID() == id) {
                    return this.models[i];
                }
            }
            return false;
        }

    });

    return Collection_Search;
})(BaseCollection);



//////////////////
// WEBPACK FOOTER
// ./js/collection/collection_search.js
// module id = 9
// module chunks = 0